import { motion } from 'framer-motion';
import { Send, Camera, FileCheck } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: Send,
    title: 'Confiez-nous le bien',
    description:
      'Transmettez-nous les informations du bien via notre formulaire en ligne. Nous nous occupons du reste.',
  },
  {
    number: '02',
    icon: Camera,
    title: 'Nous gérons tout',
    description:
      'Photos professionnelles, plans 2D, visites, rapports... Tout est pris en charge par notre équipe.',
  },
  {
    number: '03',
    icon: FileCheck,
    title: 'Recevez votre dossier',
    description:
      'Vous recevez un dossier complet prêt à l\'emploi avec tous les livrables convenus.',
  },
];

export function HowItWorks() {
  return (
    <section id="fonctionnement" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold-50 text-gold-700 text-sm font-medium border border-gold-200 mb-6"
          >
            Comment ça marche ?
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl font-display font-bold text-navy-600 mb-6"
          >
            La solution{' '}
            <span className="gradient-text">VISINOT</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-xl text-navy-300"
          >
            Un processus simple en 3 étapes pour vous libérer de l'opérationnel.
          </motion.p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto relative">
          {/* Connecting line (desktop) */}
          <div className="hidden md:block absolute top-10 left-[20%] right-[20%] h-0.5 bg-gradient-to-r from-gold-300 via-gold-500 to-gold-300" />

          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.15 }}
              className="text-center relative"
            >
              {/* Circle with icon */}
              <div className="relative inline-flex mb-6">
                <div className="w-20 h-20 rounded-full bg-gold-500 flex items-center justify-center shadow-lg">
                  <step.icon className="w-8 h-8 text-white" />
                </div>
                {/* Number badge */}
                <div className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-navy-600 border-2 border-gold-500 flex items-center justify-center">
                  <span className="text-xs font-bold text-white">{step.number}</span>
                </div>
              </div>

              <h3 className="text-xl font-display font-semibold text-navy-600 mb-3">
                {step.title}
              </h3>
              <p className="text-navy-300 leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Bottom message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="mt-16 max-w-2xl mx-auto"
        >
          <div className="rounded-2xl bg-navy-50 border border-navy-100 p-8 text-center">
            <p className="text-lg font-medium text-navy-600">
              Vous gardez le contrôle commercial.{' '}
              <span className="text-gold-600">Nous gérons l'opérationnel.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
